"use strict";

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothStripePrintCell;
var _react = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode.react");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
// Decodes an image once; resolves to null if it cannot be loaded.
var loadImage = function loadImage(src) {
  return new Promise(function (resolve) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = function () {
      return resolve(null);
    };
    img.src = src;
  });
};

// Finds the rectangular frame drawn by a filter overlay and returns the inside of that window as fractions
// of the image ({ x, y, w, h }), or null when no frame is found. The photos are laid out inside this window
// so the frame never covers a part of them.
var detectFilterWindow = function detectFilterWindow(img) {
  try {
    var scale = Math.min(1, 600 / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * scale));
    var h = Math.max(1, Math.round(img.naturalHeight * scale));
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);
    var _ctx$getImageData = ctx.getImageData(0, 0, w, h),
      data = _ctx$getImageData.data;
    var isInk = function isInk(x, y) {
      var i = (y * w + x) * 4;
      return data[i + 3] > 128 && data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114 < 110;
    };
    var longestRuns = function longestRuns(length, across, at) {
      var runs = new Array(length).fill(0);
      for (var i = 0; i < length; i++) {
        var run = 0;
        for (var j = 0; j < across; j++) {
          run = at(i, j) ? run + 1 : 0;
          if (run > runs[i]) runs[i] = run;
        }
      }
      return runs;
    };
    var groups = function groups(runs, min) {
      var out = [];
      var start = -1;
      runs.forEach(function (value, index) {
        if (value >= min) {
          if (start < 0) start = index;
        } else if (start >= 0) {
          out.push([start, index - 1]);
          start = -1;
        }
      });
      if (start >= 0) out.push([start, runs.length - 1]);
      return out;
    };
    var horizontal = groups(longestRuns(h, w, function (y, x) {
      return isInk(x, y);
    }), w * 0.5);
    var vertical = groups(longestRuns(w, h, function (x, y) {
      return isInk(x, y);
    }), h * 0.5);
    if (horizontal.length < 2 || vertical.length < 2) return null;
    var top = horizontal[0];
    var bottom = horizontal[horizontal.length - 1];
    var left = vertical[0];
    var right = vertical[vertical.length - 1];
    var frame = {
      x: (left[1] + 1) / w,
      y: (top[1] + 1) / h,
      w: (right[0] - left[1] - 1) / w,
      h: (bottom[0] - top[1] - 1) / h
    };
    return frame.w > 0.2 && frame.h > 0.3 ? frame : null;
  } catch (err) {
    console.warn('[StripePrint] could not analyse the filter frame:', err);
    return null;
  }
};
var canvasToBlob = function canvasToBlob(canvas, type, quality) {
  return new Promise(function (resolve) {
    return canvas.toBlob(resolve, type, quality);
  });
};
var blobToDataUri = function blobToDataUri(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      return resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
function PhotoboothStripePrintCell(_ref4) {
  var cell = _ref4.cell,
    screenType = _ref4.screenType,
    language = _ref4.language,
    project = _ref4.project,
    logEvent = _ref4.logEvent,
    page = _ref4.page,
    intl = _ref4.intl,
    uriTransformer = _ref4.uriTransformer;
  var _ref5 = (0, _react.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    isInitialized = _ref6[0],
    setIsInitialized = _ref6[1];
  var _ref7 = (0, _react.useState)(null),
    _ref8 = _slicedToArray(_ref7, 2),
    error = _ref8[0],
    setError = _ref8[1];
  var _ref9 = (0, _react.useState)(true),
    _ref0 = _slicedToArray(_ref9, 2),
    loading = _ref0[0],
    setLoading = _ref0[1];
  var videoRef = (0, _react.useRef)(null);
  var _ref1 = (0, _react.useState)(4),
    _ref10 = _slicedToArray(_ref1, 2),
    count = _ref10[0],
    setCount = _ref10[1]; // 4 photos pour Givenchy
  var _ref11 = (0, _react.useState)([]),
    _ref12 = _slicedToArray(_ref11, 2),
    photos = _ref12[0],
    setPhotos = _ref12[1]; // Array to store the photos taken
  var _ref13 = (0, _react.useState)({
      index: 0,
      photoUri: null
    }),
    _ref14 = _slicedToArray(_ref13, 2),
    currentPhoto = _ref14[0],
    setCurrentPhoto = _ref14[1]; // Current photo being captured
  var _ref15 = (0, _react.useState)(0),
    _ref16 = _slicedToArray(_ref15, 2),
    step = _ref16[0],
    setStep = _ref16[1]; // Step to track the current state of the photobooth
  var _ref17 = (0, _react.useState)(false),
    _ref18 = _slicedToArray(_ref17, 2),
    printed = _ref18[0],
    setPrinted = _ref18[1]; // Track if the photo has been printed
  var _ref19 = (0, _react.useState)(''),
    _ref20 = _slicedToArray(_ref19, 2),
    email = _ref20[0],
    setEmail = _ref20[1]; // Email input for sending the photo
  var _ref21 = (0, _react.useState)(''),
    _ref22 = _slicedToArray(_ref21, 2),
    link = _ref22[0],
    setLink = _ref22[1]; // Link for QR code generation
  var _ref23 = (0, _react.useState)(false),
    _ref24 = _slicedToArray(_ref23, 2),
    isSending = _ref24[0],
    setIsSending = _ref24[1]; // Track if the photo is being sent
  var _ref25 = (0, _react.useState)(false),
    _ref26 = _slicedToArray(_ref25, 2),
    started = _ref26[0],
    setStarted = _ref26[1]; // Track if the photo has been sent
  var _ref27 = (0, _react.useState)(false),
    _ref28 = _slicedToArray(_ref27, 2),
    emailSended = _ref28[0],
    setEmailSended = _ref28[1]; // Track if the email has been sent
  var _ref29 = (0, _react.useState)(null),
    _ref30 = _slicedToArray(_ref29, 2),
    currentDataUri = _ref30[0],
    setCurrentDataUri = _ref30[1]; // Current data URI of the photo being captured
  var _ref31 = (0, _react.useState)(0),
    _ref32 = _slicedToArray(_ref31, 2),
    progress = _ref32[0],
    setProgress = _ref32[1]; // Progress of the GIF creation
  var _ref33 = (0, _react.useState)(false),
    _ref34 = _slicedToArray(_ref33, 2),
    isSelected = _ref34[0],
    setIsSelected = _ref34[1]; // Track if the cell is selected
  var _ref35 = (0, _react.useState)(null),
    _ref36 = _slicedToArray(_ref35, 2),
    blops = _ref36[0],
    setBlops = _ref36[1]; // Array to store the Blobs of the photos taken
  var _ref37 = (0, _react.useState)(null),
    _ref38 = _slicedToArray(_ref37, 2),
    forPrint = _ref38[0],
    setForPrint = _ref38[1]; // Blob for printing
  var filterImageRef = (0, _react.useRef)({
    uri: null,
    promise: null
  }); // filter overlay, loaded once
  // Timing of the "last photo -> strip -> QR code" pipeline. Always logged to the console; shown on screen
  // when the page url contains ?stripeDebug (to measure on the kiosk itself).
  var timingStartRef = (0, _react.useRef)(0);
  var _ref39 = (0, _react.useState)({}),
    _ref40 = _slicedToArray(_ref39, 2),
    timings = _ref40[0],
    setTimings = _ref40[1];
  var showTimings = typeof window !== 'undefined' && /[?&]stripeDebug/.test(window.location.search);
  var markTiming = function markTiming(name) {
    var ms = Math.round(performance.now() - timingStartRef.current);
    console.log('[StripePrint][timing]', name, ms + ' ms');
    setTimings(function (previous) {
      return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, name, ms));
    });
  };
  var _ref41 = (0, _react.useState)(false),
    _ref42 = _slicedToArray(_ref41, 2),
    stripeReady = _ref42[0],
    setStripeReady = _ref42[1]; // the strip image is fully loaded and can be shown
  var previewUrlRef = (0, _react.useRef)(null); // object URL of the strip preview shown on screen
  var compositeRef = (0, _react.useRef)(null); // composite being built (or already built) for the current photos
  var photoCount = Math.min(5, Math.max(2, parseInt(cell.photo_count, 10) || 4)); // Nombre de photos sur la bande

  (0, _react.useEffect)(function () {
    function startCamera() {
      return _startCamera.apply(this, arguments);
    }
    function _startCamera() {
      _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var stream, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  width: {
                    ideal: 1920,
                    min: 1280
                  },
                  height: {
                    ideal: 1920,
                    min: 720
                  },
                  facingMode: 'user'
                }
              });
            case 1:
              stream = _context.v;
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                console.log('PhotoboothStripePrint: Video stream set and playing');
              }
              setIsInitialized(true);
              setLoading(false);
              console.log('PhotoboothStripePrint: Camera initialized successfully');
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                console.log('PhotoboothStripePrint: Video stream set and playing (second time)');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t2 = _context.v;
              setError(_t2);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _startCamera.apply(this, arguments);
    }
    startCamera();
  }, []);

  // Effect pour créer l'image composite quand toutes les photos sont prises
  (0, _react.useEffect)(function () {
    if (photos.length === photoCount && step === 3) {
      console.log('PhotoboothStripePrint: photos ready, creating composite image');
      timingStartRef.current = performance.now();
      setTimings({});
      createGif(); // Un seul appel ici
    }
  }, [step, photos]);
  var filterUri = cell.filter_uri ? uriTransformer(cell.filter_uri) : null;
  console.log('[StripePrint] cell.filter_uri =', cell.filter_uri, '| resolved filterUri =', filterUri);

  // The filter overlay never changes for a given uri: download/decode it once and reuse it.
  var getFilterImage = function getFilterImage() {
    if (!filterUri) return Promise.resolve(null);
    if (filterImageRef.current.uri !== filterUri) {
      filterImageRef.current = {
        uri: filterUri,
        promise: loadImage(filterUri).then(function (img) {
          if (!img) console.error('[StripePrint] Filter image failed to load:', filterUri);
          return img;
        })
      };
    }
    return filterImageRef.current.promise;
  };
  (0, _react.useEffect)(function () {
    getFilterImage(); // preload while the visitor is posing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterUri]);
  var drawFilterOverlay = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ctx, width, height) {
      var filterImg;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (filterUri) {
              _context2.n = 1;
              break;
            }
            console.warn('[StripePrint] No filterUri — skipping overlay');
            return _context2.a(2);
          case 1:
            _context2.n = 2;
            return getFilterImage();
          case 2:
            filterImg = _context2.v;
            if (filterImg) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2);
          case 3:
            try {
              ctx.drawImage(filterImg, 0, 0, width, height);
            } catch (err) {
              console.error('[StripePrint] Error drawing filter to canvas:', err);
            }
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function drawFilterOverlay(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  // Mise en page de référence (unités de design). L’export est multiplié par `scale`
  // pour coller au mieux à la résolution des captures sans dépasser les limites canvas du navigateur.
  var STRIPE_BASE_PHOTO_W = 197;
  var STRIPE_BASE_PHOTO_H = 150;
  var STRIPE_BASE_H_MARGIN = 43;
  var STRIPE_BASE_V_MARGIN = 80;
  var STRIPE_BASE_STROKE = 4;
  // Export at most 4x the reference layout (1132x3040 px): sharper than the printer needs, and the canvas
  // stays small enough to encode and upload quickly on a kiosk.
  var STRIPE_MAX_EXPORT_SCALE = 4;

  // La bande garde la même taille quel que soit le nombre de photos : elles se partagent la hauteur de la grille.
  var STRIPE_BASE_GRID_H = STRIPE_BASE_PHOTO_H * 4;
  var stripeSlotBaseH = STRIPE_BASE_GRID_H / photoCount;
  var computeStripeExportLayout = function computeStripeExportLayout(photoImages, filterWindow) {
    var baseCanvasW = STRIPE_BASE_PHOTO_W + STRIPE_BASE_H_MARGIN * 2;
    var baseCanvasH = STRIPE_BASE_GRID_H + STRIPE_BASE_V_MARGIN * 2;
    var maxEdge = typeof window !== 'undefined' ? Math.min(8192, Math.max(4096, 2048 * (window.devicePixelRatio || 1))) : 8192;
    var valid = photoImages.slice(0, photoCount).filter(Boolean).map(function (img) {
      return {
        w: img.naturalWidth,
        h: img.naturalHeight
      };
    }).filter(function (s) {
      return s.w > 0 && s.h > 0;
    });
    var scale = 4;
    if (valid.length) {
      var minW = Math.min.apply(Math, _toConsumableArray(valid.map(function (s) {
        return s.w;
      })));
      var minH = Math.min.apply(Math, _toConsumableArray(valid.map(function (s) {
        return s.h;
      })));
      var bySource = Math.min(minW / STRIPE_BASE_PHOTO_W, minH / stripeSlotBaseH);
      var byCanvas = Math.min(maxEdge / baseCanvasW, maxEdge / baseCanvasH);
      scale = Math.floor(Math.min(bySource, byCanvas));
    }
    scale = Math.max(2, Math.min(scale, STRIPE_MAX_EXPORT_SCALE));
    var canvasWidth = baseCanvasW * scale;
    var canvasHeight = baseCanvasH * scale;
    // With a filter frame, the photos fill exactly the inside of the frame (whatever the number of photos);
    // otherwise use the reference layout.
    var photoWidth = filterWindow ? filterWindow.w * canvasWidth : STRIPE_BASE_PHOTO_W * scale;
    var photoHeight = filterWindow ? filterWindow.h * canvasHeight / photoCount : stripeSlotBaseH * scale;
    var horizontalMargin = filterWindow ? filterWindow.x * canvasWidth : STRIPE_BASE_H_MARGIN * scale;
    var verticalMargin = filterWindow ? filterWindow.y * canvasHeight : STRIPE_BASE_V_MARGIN * scale;
    var strokeWidth = Math.max(2, Math.round(STRIPE_BASE_STROKE * scale));
    console.log('[StripePrint] Export layout', {
      scale: scale,
      canvasWidth: canvasWidth,
      canvasHeight: canvasHeight,
      photoWidth: photoWidth,
      photoHeight: photoHeight
    });
    return {
      scale: scale,
      photoWidth: photoWidth,
      photoHeight: photoHeight,
      horizontalMargin: horizontalMargin,
      verticalMargin: verticalMargin,
      canvasWidth: canvasWidth,
      canvasHeight: canvasHeight,
      strokeWidth: strokeWidth
    };
  };
  var drawStripePhotos = function drawStripePhotos(ctx, layout, photoImages) {
    var photoWidth = layout.photoWidth,
      photoHeight = layout.photoHeight,
      horizontalMargin = layout.horizontalMargin,
      verticalMargin = layout.verticalMargin,
      strokeWidth = layout.strokeWidth;
    var gridX = horizontalMargin;
    var gridY = verticalMargin;
    ctx.imageSmoothingEnabled = true;
    if ('imageSmoothingQuality' in ctx) {
      ctx.imageSmoothingQuality = 'high';
    }
    for (var index = 0; index < Math.min(photoImages.length, photoCount); index++) {
      var photoImg = photoImages[index];
      if (!photoImg) continue;
      var pos = {
        x: gridX,
        y: gridY + index * photoHeight
      };
      var imgAspect = photoImg.width / photoImg.height;
      var photoAspect = photoWidth / photoHeight;
      var sourceX = 0;
      var sourceY = 0;
      var sourceWidth = photoImg.width;
      var sourceHeight = photoImg.height;
      if (imgAspect > photoAspect) {
        sourceWidth = photoImg.height * photoAspect;
        sourceX = (photoImg.width - sourceWidth) / 2;
      } else {
        sourceHeight = photoImg.width / photoAspect;
        sourceY = (photoImg.height - sourceHeight) / 2;
      }
      ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, pos.x, pos.y, photoWidth, photoHeight);
      ctx.strokeStyle = 'black';
      ctx.lineWidth = strokeWidth;
      ctx.strokeRect(pos.x, pos.y, photoWidth, photoHeight);
    }
  };
  var createGif2 = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var photoImages, filterImage, layout, canvasWidth, canvasHeight, canvas, ctx, previewBlob, previewUrl, preload, pngBlob, finalImageDataUri, _t3, _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.n = 1;
            return Promise.all(photos.slice(0, photoCount).map(function (uri) {
              return uri ? loadImage(uri) : null;
            }));
          case 1:
            photoImages = _context3.v;
            markTiming('1 photos decoded');
            _context3.n = 2;
            return getFilterImage();
          case 2:
            filterImage = _context3.v;
            if (filterImage && filterImageRef.current.window === undefined) {
              filterImageRef.current.window = detectFilterWindow(filterImage);
            }
            layout = computeStripeExportLayout(photoImages, filterImage ? filterImageRef.current.window : null);
            canvasWidth = layout.canvasWidth, canvasHeight = layout.canvasHeight;
            canvas = document.createElement('canvas');
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            ctx = canvas.getContext('2d');
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
            drawStripePhotos(ctx, layout, photoImages);
            _context3.n = 3;
            return drawFilterOverlay(ctx, canvasWidth, canvasHeight);
          case 3:
            markTiming('2 strip drawn (filter included)');
            _context3.p = 4;
            _context3.n = 5;
            return canvasToBlob(canvas, 'image/jpeg', 0.92);
          case 5:
            previewBlob = _context3.v;
            markTiming('3 jpeg preview encoded');
            if (!previewBlob) {
              _context3.n = 10;
              break;
            }
            // The QR code only appears once this upload is done, so start it right now with the light
            // JPEG (a few hundred KB) instead of waiting for, then sending, the multi-MB PNG.
            blobToDataUri(previewBlob).then(function (jpegDataUri) {
              return handleShare(jpegDataUri);
            });

            // Decode the image before showing it, so it never appears half loaded.
            previewUrl = URL.createObjectURL(previewBlob);
            preload = new Image();
            preload.src = previewUrl;
            _context3.p = 6;
            _context3.n = 7;
            return preload.decode();
          case 7:
            _context3.n = 9;
            break;
          case 8:
            _context3.p = 8;
            _t3 = _context3.v;
            console.warn('[StripePrint] preview decode failed, showing it anyway:', _t3);
          case 9:
            if (previewUrlRef.current) URL.revokeObjectURL(previewUrlRef.current);
            previewUrlRef.current = previewUrl;
            setCurrentDataUri(previewUrl);
          case 10:
            _context3.n = 11;
            return canvasToBlob(canvas, 'image/png');
          case 11:
            pngBlob = _context3.v;
            if (pngBlob) {
              _context3.n = 12;
              break;
            }
            throw new Error('canvas.toBlob returned null');
          case 12:
            markTiming('6 png encoded');
            _context3.n = 13;
            return blobToDataUri(pngBlob);
          case 13:
            finalImageDataUri = _context3.v;
            console.log('[StripePrint] createGif2 composite ready, dataUri length:', finalImageDataUri.length);
            setForPrint(finalImageDataUri);
            setBlops(pngBlob);
            if (!previewBlob) handleShare(finalImageDataUri);
            return _context3.a(2, finalImageDataUri);
          case 14:
            _context3.p = 14;
            _t4 = _context3.v;
            console.error('[StripePrint] composite export failed (likely tainted canvas / CORS):', _t4);
            return _context3.a(2, null);
        }
      }, _callee3, null, [[6, 8], [4, 14]]);
    }));
    return function createGif2() {
      return _ref2.apply(this, arguments);
    };
  }();
  var createGif = function createGif() {
    var composite = createGif2();
    compositeRef.current = composite;
    return composite;
  };
  var handleShare = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(imageData) {
      var imageToSend, response, record, _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            imageToSend = imageData || forPrint;
            console.log('[StripePrint] handleShare called, imageToSend length:', imageToSend && imageToSend.length, 'from param?', !!imageData);
            if (imageToSend) {
              _context4.n = 1;
              break;
            }
            console.error('[StripePrint] Aucune image à partager');
            return _context4.a(2);
          case 1:
            _context4.p = 1;
            setIsSending(true);

            // Envoyer directement l'image composite (grille de 4 photos)
            _context4.n = 2;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: imageToSend,
                // Utiliser l'image fraîchement composée
                email: null // Pas d'email pour Givenchy
              })
            });
          case 2:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 3;
              break;
            }
            throw new Error('Upload failed');
          case 3:
            _context4.n = 4;
            return response.json();
          case 4:
            record = _context4.v;
            setLink(record.image_uri);
            markTiming('5 link received (QR code)');
            logEvent('click', {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: 'send_photo',
              email: null,
              // Pas d'email pour Givenchy
              link: record.image_uri
            });
            console.log('Photo grille PhotoboothStripePrint partagée avec succès');
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t5 = _context4.v;
            console.error('Error sending photo:', _t5);
          case 6:
            _context4.p = 6;
            setIsSending(false);
            console.log('Photo sent successfully');
            return _context4.f(6);
          case 7:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 5, 6, 7]]);
    }));
    return function handleShare(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  function handlePrintCall() {
    return _handlePrintCall.apply(this, arguments);
  }
  function _handlePrintCall() {
    _handlePrintCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var printUri, _t6, _t7;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!printed) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            _context5.p = 1;
            _t6 = forPrint;
            if (_t6) {
              _context5.n = 3;
              break;
            }
            _context5.n = 2;
            return compositeRef.current || createGif();
          case 2:
            _t6 = _context5.v;
          case 3:
            printUri = _t6;
            if (printUri) {
              _context5.n = 4;
              break;
            }
            console.error('[StripePrint] Pas d’image composite pour l’impression');
            return _context5.a(2);
          case 4:
            // Imprimer directement l'image composite (grille de 4 photos)
            if (window.electronAPI) {
              window.electronAPI.sendImageForPrint(printUri);
            }
            if (window.Android && typeof window.Android.postMessage === 'function') {
              window.Android.postMessage(printUri);
            }
            setPrinted(true);
            console.log('Image grille PhotoboothStripePrint envoyée pour impression:', printUri);
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t7 = _context5.v;
            console.log('Error');
          case 6:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 5]]);
    }));
    return _handlePrintCall.apply(this, arguments);
  }
  function capturePhotoSequence() {
    console.log('PhotoboothStripePrint: capturePhotoSequence started, started state:', started);
    if (started) {
      console.log('PhotoboothStripePrint: Already started, returning');
      return; // Prevent multiple captures
    }
    console.log('PhotoboothStripePrint: Setting started to true');
    setStarted(true);
    var totalPhotos = photoCount;
    var countdownTime = 4;
    setStep(1);
    setPhotos([]); // reset existing photos
    setForPrint(null); // the previous composite must not be printed for the new photos
    compositeRef.current = null;
    setCurrentDataUri(null);
    setStripeReady(false);
    setLink('');
    setPrinted(false);
    var currentPhoto = 0;
    function countdownAndCapture() {
      var currentCount = countdownTime;
      var countdownInterval = setInterval(function () {
        setCount(currentCount - 1);
        --currentCount;
        if (currentCount <= 0) {
          clearInterval(countdownInterval);
          captureOnePhoto(function (photo) {
            console.log('PhotoboothStripePrint: Photo captured:', currentPhoto + 1, 'Total photos:', photos.length + 1);
            setPhotos(function (prev) {
              var newPhotos = [].concat(_toConsumableArray(prev), [photo]);
              console.log('PhotoboothStripePrint: Updated photos array:', newPhotos.length);
              return newPhotos;
            });
            currentPhoto++;
            if (currentPhoto < totalPhotos) {
              countdownAndCapture();
            } else {
              console.log('PhotoboothStripePrint: All photos captured, moving to step 3');
              setStep(3);
              // Ne pas appeler createGif() ici car l'état photos n'est pas encore mis à jour
            }
          });
        }
      }, 1000);
    }
    countdownAndCapture();
  }
  function captureOnePhoto(callback) {
    console.log('PhotoboothStripePrint: captureOnePhoto called');
    var video = videoRef.current;
    if (!video) {
      console.error('PhotoboothStripePrint: No video element found');
      return;
    }
    var canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    if ('imageSmoothingQuality' in ctx) {
      ctx.imageSmoothingQuality = 'high';
    }
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    var photoDataUrl = canvas.toDataURL('image/jpeg', 0.95);
    console.log('PhotoboothStripePrint: Photo data URL created, length:', photoDataUrl.length);
    callback(photoDataUrl);
  }
  if (!isInitialized && loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : 'arial',
        color: cell.text_color,
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '60%',
        margin: 'auto',
        height: '60%',
        fontSize: '3em',
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "Initialisation de la cam\xE9ra..."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(LoadingSvg, {
      cell: cell,
      animated: true
    })));
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : 'arial',
        color: 'red',
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '80%',
        margin: 'auto',
        height: '80%',
        fontSize: '2em',
        textAlign: 'center'
      }
    }, "Erreur d'acc\xE8s \xE0 la cam\xE9ra : ", error.message));
  }
  switch (step) {
    case 0:
    case 1:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        style: {
          display: 'none'
        },
        autoPlay: true,
        muted: true,
        playsInline: true
      }), !isInitialized && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '1em',
          textAlign: 'center',
          zIndex: 4
        }
      }, "Initialisation de la cam\xE9ra..."), step === 1 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          fontSize: '1.6em',
          fontWeight: 'bold',
          textAlign: 'center',
          zIndex: 4,
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          letterSpacing: '1px'
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '70%',
          aspectRatio: '1 / 1',
          background: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(15px)',
          borderRadius: '0',
          border: '4px solid black',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          marginTop: '-34%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        ref: videoRef,
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '0',
          zIndex: -1
        },
        autoPlay: true,
        muted: true,
        playsInline: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '0',
          zIndex: 0
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          zIndex: 1,
          position: 'relative'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          console.log('PhotoboothStripePrint: Preview clicked, isInitialized:', isInitialized, 'started:', started);
          if (isInitialized && !started) {
            capturePhotoSequence();
          }
        },
        style: {
          width: '180px',
          height: '180px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          border: '2px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '4em',
          fontWeight: 'bold',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          cursor: isInitialized && !started ? 'pointer' : 'default',
          backdropFilter: 'blur(10px)'
        }
      }, step === 1 ? /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '2em',
          fontWeight: 'bold',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)'
        }
      }, count) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60px',
          height: '60px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: {
          filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
        }
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "13",
        r: "3"
      })))), !started && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '1.1em',
          fontWeight: 'bold',
          textAlign: 'center',
          letterSpacing: '1px',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          color: 'white',
          textTransform: 'uppercase'
        }
      }, "PRENDRE LA PHOTO"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          bottom: '14%',
          left: 0,
          right: 0,
          padding: '0 4%',
          boxSizing: 'border-box',
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'nowrap',
          zIndex: 3
        }
      }, Array.from({
        length: photoCount
      }, function (_, index) {
        return index;
      }).map(function (index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          style: {
            flex: '0 1 220px',
            minWidth: 0,
            aspectRatio: '1 / 1',
            borderRadius: '0',
            background: photos[index] ? 'white' : index === 0 ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
            backgroundSize: 'cover',
            border: '4px solid black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.6em',
            fontWeight: 'bold',
            color: photos[index] ? '#333' : index === 0 ? '#333' : 'white',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            textShadow: photos[index] ? 'none' : index === 0 ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(5px)'
          }
        }, photos[index] ? /*#__PURE__*/_react.default.createElement("img", {
          src: photos[index],
          alt: "Photo ".concat(index + 1),
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '0'
          }
        }) : /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: '1.6em',
            fontWeight: 'bold',
            textShadow: index === 0 ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.5)'
          }
        }, index + 1));
      })));
    case 2:
      console.log('PhotoboothStripePrint: Rendering case 2, photos available:', photos.length, photos);
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("style", null, "\n                            .selectable:hover {\n                                cursor: pointer;\n                                opacity: 0.8;\n                                scale: 1.05;\n                                transform-origin: center;\n                            }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          height: '64%',
          border: 'solid 0.5em ' + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: photos[currentPhoto.index] || photos[0],
        alt: "Photo ".concat(currentPhoto.index + 1),
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: isSelected ? 1 : 0.4
        }
      }), !isSelected && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          left: 0,
          textAlign: 'center',
          fontSize: '2em',
          position: 'absolute',
          width: '100%',
          top: '58%',
          color: 'white',
          display: 'flex'
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          margin: 'auto',
          textAlign: 'center'
        }
      }, "choisis ta photo"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          height: '18%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          gap: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 0
          });
          setIsSelected(true);
        },
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 0 ? 1 : 0.6,
          cursor: 'pointer',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 1
          });
          setIsSelected(true);
        },
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 1 ? 1 : 0.6,
          cursor: 'pointer',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 2
          });
          setIsSelected(true);
        },
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 2 ? 1 : 0.6,
          cursor: 'pointer',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "3"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[3] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 3
          });
          setIsSelected(true);
        },
        src: photos[3],
        alt: "Photo 4",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 3 ? 1 : 0.6,
          cursor: 'pointer',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "4")))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'row'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                setStarted(false);
                setStep(0);
                setPhotos([]);
                setCurrentPhoto({
                  index: 0
                });
                setIsSelected(false);
              case 1:
                return _context6.a(2);
            }
          }, _callee6);
        })),
        style: {
          width: '100%',
          margin: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          background: 'rgba(255,255,255,0.4)',
          padding: '1em',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'white',
          fontSize: '1.2em',
          marginLeft: '1em'
        }
      }, "Recommencer")), isSelected && /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                setStep(3);
                createGif();
              case 1:
                return _context7.a(2);
            }
          }, _callee7);
        })),
        style: {
          width: '100%',
          margin: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          background: 'white',
          padding: '1em',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'black',
          fontSize: '1.2em',
          marginLeft: '1em'
        }
      }, "Continuer"))));
    case 3:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }
      }, showTimings && /*#__PURE__*/_react.default.createElement("pre", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
          margin: 0,
          padding: '4px 8px',
          background: 'rgba(0,0,0,0.75)',
          color: '#0f0',
          fontSize: '11px',
          textAlign: 'left'
        }
      }, 'ms after the last photo\n' + Object.keys(timings).sort().map(function (name) {
        return name + ': ' + timings[name];
      }).join('\n')), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container",
        style: {
          width: '100%',
          margin: '20% 0 auto',
          height: '58%',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, currentDataUri && /*#__PURE__*/_react.default.createElement("img", {
        src: currentDataUri,
        alt: "Photo strip preview",
        onLoad: function onLoad() {
          setStripeReady(true);
          markTiming('4 strip painted on screen');
        },
        style: {
          height: '100%',
          width: 'auto',
          display: 'block',
          border: '4px solid black',
          transform: 'scaleX(1.2)',
          visibility: stripeReady ? 'visible' : 'hidden'
        }
      }), !(currentDataUri && stripeReady) && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: true
      }), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: '1.4em',
          fontWeight: 'bold',
          textAlign: 'center',
          padding: '0 10%'
        }
      }, "Votre photo est en cours de pr\xE9paration"))), currentDataUri && stripeReady && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          padding: '0.4em',
          width: '80%',
          margin: '3em auto 0',
          display: 'flex',
          gap: '1em',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", {
        style: {
          textAlign: 'center',
          color: 'white',
          margin: '0.3em 0'
        }
      }, "Imprimer la photo ou scanner le QR code"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          padding: '1em',
          alignItems: 'flex-end',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: printed,
        style: {
          width: '5em',
          height: '5em',
          background: 'white',
          color: 'black',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          fontSize: '1em',
          fontWeight: 'bold',
          opacity: printed ? 0.6 : 1,
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        onClick: handlePrintCall
      }, printed ? 'PRINTED' : 'PRINT')), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '0.5em'
        }
      }, link && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'white',
          fontSize: '1em',
          fontWeight: 900,
          whiteSpace: 'nowrap'
        }
      }, "SCAN ME"), /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
        value: link,
        size: 256,
        style: {
          width: '5em',
          height: '5em',
          display: 'block'
        }
      })))))));
    default:
      return null;
  }
}
function LoadingSvg(_ref43) {
  var cell = _ref43.cell,
    animated = _ref43.animated;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 50 50",
    style: {
      animation: animated ? 'spin 1s linear infinite' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n                    @keyframes spin {\n                        0% { transform: rotate(0deg); }\n                        100% { transform: rotate(360deg); }\n                    }\n                "), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    stroke: cell.text_color,
    strokeWidth: "5",
    strokeDasharray: "31.416",
    strokeDashoffset: "31.416"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    values: "0 31.416;15.708 15.708;0 31.416",
    repeatCount: "indefinite"
  })));
}